import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MultiselectItem, MultiselectSettings, State } from '../../../core/interfaces/admin.interface';
import { MULTI_SELECT_SETTING, EMULTI_SELECT_SETTING } from '../../../core/settings/settings.service';

@Component({
  selector: 'sacbo-state-select',
  templateUrl: './state-select.component.html',
  styleUrls: ['./state-select.component.scss']
})
export class StateSelectComponent {

  @Input() stateSelected: MultiselectItem[] = [];
  @Output() stateSelectedChange = new EventEmitter< MultiselectItem[]>();
  @Output() onSelected = new EventEmitter< MultiselectItem[]>();
  @Input() singleSelection: boolean = null;

  protected readonly multiselectSettings = MULTI_SELECT_SETTING;
  protected readonly EMULTI_SELECT_SETTING = EMULTI_SELECT_SETTING;

  get computedSettings(): MultiselectSettings {
    if (this.singleSelection != null) {
      return { ...MULTI_SELECT_SETTING[EMULTI_SELECT_SETTING.NO_SEARCH], singleSelection: this.singleSelection };
    }
    return MULTI_SELECT_SETTING[EMULTI_SELECT_SETTING.NO_SEARCH];
  }

  statesList: MultiselectItem[] = [];

  constructor() {

    this.statesList = [{ id: State.ACTIVE, itemName: 'Active' }, { id: State.INACTIVE, itemName: 'In Active' }];

  }

  onStateSelect(): void {
    this.stateSelectedChange.emit(this.stateSelected);
    this.onSelected.emit(this.stateSelected);
  }

}
